module.exports = __webpack_public_path__ + "assets/img/btn-back-d3b99c6b.png";